module.exports = __webpack_public_path__ + "assets/2.2b7b2045.svg";